import {HttpErrorResponse} from "@angular/common/http";

import {ErrorCodeConstant} from "../constant/error-code.constant";

export class SilentErrorUtil {

    private static readonly SILENT_ERROR_CODES: number[] = [
        ErrorCodeConstant.JOB_POST_TALENT_ASSIGNMENT_NOT_FOUND,
        ErrorCodeConstant.COMPETITION_NOT_READY_TO_PUBLISH
    ];

    static isSilentError(httpErrorResponse: HttpErrorResponse): boolean {
        return SilentErrorUtil.SILENT_ERROR_CODES.includes(httpErrorResponse?.error?.errorCode?.code);
    }
}
